import React, { useEffect } from 'react';
import { Button, TextField } from '@mui/material';
import styles from './EmailConfirmation.module.scss';

export const EmailConfirmation = ({ email, onConfirm, onChangeEmail }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className={styles.emailConfirmationContainer}>
      <h2>Подтверждение электронной почты</h2>
      <p>Это ваш e-mail?</p>
      <TextField
        value={email}
        variant="outlined"
        fullWidth
        disabled
        margin="normal"
        sx={{
          '@media (max-width: 450px)': {
            margin: '8px 0'
          }
        }}
      />
      <div className={styles.buttonContainer}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onConfirm}
          sx={{
            '@media (max-width: 450px)': {
              padding: '10px'
            }
          }}
        >
          Да
        </Button>
        <Button 
          variant="outlined" 
          color="secondary" 
          onClick={onChangeEmail}
          sx={{
            '@media (max-width: 450px)': {
              padding: '10px'
            }
          }}
        >
          Нет
        </Button>
      </div>
    </div>
  );
};
